import { VerifyOtpPage } from '@/pages/verify-otp';
import { createFileRoute } from '@tanstack/react-router';
import { ErrorFallBack } from '@drisk-ai/ui';
import { z } from 'zod';

const verifyOtpSearchSchema = z.object({
  token: z.string().optional(),
});

export const Route = createFileRoute('/_public/verify-otp')({
  validateSearch: search => verifyOtpSearchSchema.parse(search),
  beforeLoad: async ({ search }) => {
    const token = search.token;

    if (!token) {
      throw new Error('Missing token in URL, please sign in again');
    }
  },
  errorComponent: ({ error }) => (
    <ErrorFallBack
      title="Error"
      description={error.message}
      buttonLabel="Go Back"
      onClick={() => {
        history.back();
      }}
    />
  ),
  component: VerifyOtpPage,
});
